export const complementos = () => {
  return [
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/c1_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/c1_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c1_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c1_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/c2_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/c2_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c2_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c2_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/c3_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/c3_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c3_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c3_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/c4_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/c4_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c4_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c4_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/c5_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/c5_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c5_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/c5_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    }
  ]
}
